import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { GraphQlQueryResult, QuerySuccessResultCreator } from '../../graphql-result';
export var RecommendationSuccessResultCreator = /*#__PURE__*/function (_QuerySuccessResultCr) {
  _inherits(RecommendationSuccessResultCreator, _QuerySuccessResultCr);
  var _super = _createSuper(RecommendationSuccessResultCreator);
  function RecommendationSuccessResultCreator(response, data) {
    var _this;
    _classCallCheck(this, RecommendationSuccessResultCreator);
    _this = _super.call(this, response, data);
    _this.response = response;
    return _this;
  }
  _createClass(RecommendationSuccessResultCreator, [{
    key: "makeQueryResult",
    value: function makeQueryResult() {
      return new GraphQlQueryResult(this.response.status, this.response.statusText, {
        data: this.data
      });
    }
  }]);
  return RecommendationSuccessResultCreator;
}(QuerySuccessResultCreator);